import { Card, Space, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { Link, useOutletContext } from "react-router";

export default function RegisterPage() {
  const { t } = useTranslation();
  const { isDark } = useOutletContext<{ isDark: boolean }>();
  const cardClassName = isDark
    ? "w-full max-w-md rounded-3xl border border-white/10 bg-slate-900/80 text-white shadow-2xl backdrop-blur"
    : "w-full max-w-md rounded-3xl border border-slate-200/60 bg-white/80 text-slate-900 shadow-2xl backdrop-blur";
  const subtitleClassName = isDark ? "text-slate-300" : "text-slate-600";
  const hintClassName = isDark ? "text-slate-300" : "text-slate-500";

  return (
    <Card className={cardClassName}>
      <Space orientation="vertical" size="large" className="w-full">
        <Typography.Paragraph className={subtitleClassName}>
          {t("auth.registerNotice")}
        </Typography.Paragraph>

        <Typography.Text className={`text-center ${hintClassName}`}>
          {t("auth.haveAccount")}{" "}
          <Link to="/login">{t("auth.signInLink")}</Link>
        </Typography.Text>
      </Space>
    </Card>
  );
}
